/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use it for RNA?`)
};

const es_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo usarla para ARN?`)
};

const de_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich es für RNA verwenden?`)
};

const nl_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik het gebruiken voor RNA?`)
};

const fr_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je l'utiliser pour l'ARN ?`)
};

const it_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usarlo per l'RNA?`)
};

const pt_br2_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usá-la para RNA?`)
};

const pt_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usá-la para ARN?`)
};

const ja_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNAにも使えますか？`)
};

const zh_dnamw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以用于 RNA 吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_q4", locale)
	if (locale === "en") return en_dnamw_faq_q4(inputs)
	if (locale === "es") return es_dnamw_faq_q4(inputs)
	if (locale === "de") return de_dnamw_faq_q4(inputs)
	if (locale === "nl") return nl_dnamw_faq_q4(inputs)
	if (locale === "fr") return fr_dnamw_faq_q4(inputs)
	if (locale === "it") return it_dnamw_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_q4(inputs)
	if (locale === "pt") return pt_dnamw_faq_q4(inputs)
	if (locale === "ja") return ja_dnamw_faq_q4(inputs)
	return zh_dnamw_faq_q4(inputs)
};